// Kick off Strava OAuth and return the user to `returnPath` after the round-trip.
// StravaAuthCallbackPage reads localStorage 'stravaOAuthReturnUrl' and navigates back there
// (honouring it even for brand-new accounts). Mirrors App.js's handleStravaConnect so the
// referral/event landing pages can send a signed-out visitor to connect and come back.
const STRAVA_CLIENT_ID = '159733';
const STRAVA_SCOPE = 'activity:read,activity:read_all,activity:write,profile:read_all';

export function startStravaConnect(returnPath) {
  try {
    if (returnPath) localStorage.setItem('stravaOAuthReturnUrl', returnPath);
    const state = Math.random().toString(36).substring(2);
    localStorage.setItem('stravaOAuthState', state);
    const redirectUri = window.location.origin + '/strava-auth-callback';
    window.location.href =
      `https://www.strava.com/oauth/authorize?client_id=${STRAVA_CLIENT_ID}` +
      `&redirect_uri=${encodeURIComponent(redirectUri)}&response_type=code` +
      `&scope=${encodeURIComponent(STRAVA_SCOPE)}&approval_prompt=auto&state=${state}`;
  } catch (_) {
    /* storage unavailable; nothing we can do without it */
  }
}
